import { render, staticRenderFns } from "./BlogsWithGraphCMS.vue?vue&type=template&id=2de18177&"
import script from "./BlogsWithGraphCMS.vue?vue&type=script&lang=js&"
export * from "./BlogsWithGraphCMS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports